import React, {useCallback, useEffect, useState} from "react";
import Indicators from "./Indicators";
import PropTypes from "prop-types";
import SheComVerticalLogo from "./SheComVerticalLogo";
import Slider from 'react-slick';
import classNames from "classnames";
import 'whatwg-fetch';


const settings = {
  autoplay: false,
  draggable: false,
  arrows: false,
  fade: true,
  swipe: false,
  swipeToSlide: false,
  afterChange: () =>
  {
    document.getElementById('shebannerlogo').href=document.querySelector(".slick-active .superbanner__link").href
    // var parentslide = document.querySelector('.slick-active');
    // var child = parentslide.querySelector('.superbanner__item');
    // var containers = document.querySelectorAll('.superbanner__container');
    // containers.forEach((container) => {
    //   if (child.classList.contains('left')){
    //     container.classList.add("left")
    //     console.log('left')
    //   }else{
    //     container.classList.remove("left")
    //     console.log('center')
    //   }
    //
    // });

  },
  beforeChange: (current, next) =>{

    var slides = document.querySelectorAll('.slick-slide');
    var container = document.querySelector('.superbanner__container');
    var parentslide = slides[next];
    var child = parentslide.querySelector('.superbanner__item');
    // console.log(current);
    // console.log(next);
    console.log(slides[next]);
      if (child.classList.contains('left')){
        container.classList.add("left")
        console.log('left')
      }else{
        container.classList.remove("left")
        console.log('center')
      }
  }
};

export default class Superbanner extends React.Component {

  constructor () {
    super();

    this.sliderRef = React.createRef();

    this.state = {
      activeIndex: 0,
    };
    this.menuElement = null;

    this.updateActiveIndex = this.updateActiveIndex.bind(this);
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.sliderRef.current && prevState.activeIndex !== this.state.activeIndex) {
      this.sliderRef.current.slickGoTo(this.state.activeIndex);
    }
  }

  updateActiveIndex (index) {
    this.setState({activeIndex: index});
  }

  render () {
    const {items, theme} = this.props;

    /**
     * Show nothing when there isn't any banner items
     */
    if (!Array.isArray(items) || items.length === 0) { return null; }
    console.log(items[0].positionset);
    return (
      <div className="superbanner" style={{maxHeight: document.documentElement.clientHeight}}>
        <div className="superbanner__inner">
          <div className="superbanner__slider">
            <Slider
              ref={this.sliderRef}
              {...settings}
            >
              {items.map((item, index) => (
                 <div key={index}>
                  <div className={classNames('superbanner__item', `superbanner__item--${item.categorySlug}`, `${item.positionset}` , `${item.extra}`)}>
                    <a className="superbanner__link" href={`${item.url}?utm_source=${theme}&utm_medium=referral_web&utm_campaign=superbanner&utm_content=${item.post_title}`} target="_self">&nbsp;</a>
                    <div className="superbanner__item__thumbnail superbanner__item__thumbnail--desktop" style={{backgroundImage: `url(${item.thumbnail_desktop})`}} />
                    <div className="superbanner__item__thumbnail superbanner__item__thumbnail--mobile" style={{backgroundImage: `url(${item.thumbnail_mobile})`}} />
                    <div className="superbanner__item__inner" style={{maxHeight: document.documentElement.clientHeight}}>
                      <div className="superbanner__item__text">
                        <a class="superbanner__item__category" href={`/${item.categorySlug}`} target="_self" dangerouslySetInnerHTML={{__html: item.categoryLabel}} />
                        <a class="superbanner__item__title" href={item.url} target="_self">{item.post_title}</a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
            <Indicators
              count={items.length}
              activeIndex={this.state.activeIndex}
              updateActiveIndex={this.updateActiveIndex}
            />
            <div className="superbanner__read-more" />
          </div>
          <div className={classNames('superbanner__container' ,`${items[0].positionset}` )}>
            <SheComVerticalLogo theme={this.props.theme} />
          </div>
        </div>
      </div>
    );
  }
}

Superbanner.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    categoryLabel: PropTypes.string.isRequired,
    categorySlug: PropTypes.string.isRequired,
    post_title: PropTypes.string.isRequired,
    thumbnail_desktop: PropTypes.string.isRequired,
    thumbnail_mobile: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    extra:PropTypes.string.isRequired,
    positionset:PropTypes.string.isRequired,
  })).isRequired,
  theme: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/Superbanner/index.js